import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-brand-dark text-white text-center" data-id="element-53">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <h2 className="font-serif text-3xl md:text-5xl font-bold mb-8 text-brand-cream" data-id="element-55">
          Esto no es una dieta más.
          <br data-id="element-56" />
          Es libertad.
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-57">
          Imagina despertar el próximo lunes sintiéndote ligera. Imagina que esa
          blusa vuelve a caerte perfecta. Tu nuevo metabolismo empieza hoy.
        </p>

        <Button variant="primary" size="xl" className="min-w-[300px] text-lg font-bold shadow-brand-gold/20 shadow-xl" onClick={() => document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-58">
          COMENZAR MI TRANSFORMACIÓN
          <ArrowRight className="ml-2 h-5 w-5" data-id="element-59" />
        </Button>
      </div>
    </section>;
}